<template>
    <div id="achievement-tab">
        <div>
            <div class="achievement-body">
                <b-row>
                    <b-col sm="12" md="8" class="pr-md-0">
                        <div class="achievement-content">
                            <div>
                                <b-row>
                                </b-row>
                            </div>
                            <div>
                                <div class="data-container">
                                    <b-table :items="list"
                                        :fields="fields"
                                        :current-page="currentPage"
                                        ref="achievementList"
                                        responsive>

                                        <template slot="no" slot-scope="data">
                                            {{ data.index + 1}}
                                        </template>
                                        <template slot="milestone" slot-scope="data">
                                            <span class="align-middle">{{ data.value }}</span>
                                            <i class="ic-tooltip ml-1" :id="data.value" v-bind:class="{ 'd-none': data.item.tooltip == '' || !data.item.tooltip }"></i>
                                            <b-popover
                                                :target="data.value"
                                                triggers="hover"
                                                :content="data.item.tooltip"
                                            ></b-popover>
                                        </template>
                                        <template slot="published" slot-scope="data">
                                            <switches
                                                :id="`toggle-visibility-${data.item.name.replaceAll('_', '-')}`"
                                                v-model="data.value"
                                                theme="custom"
                                                color="primary"
                                                type-bold="true"
                                                text-enabled="On"
                                                text-disabled="Off"
                                                style="top: 0px">
                                            </switches>
                                        </template>
                                        <template slot="id" slot-scope="data">
                                            <b-row no-gutters>
                                                <b-col class="text-center">
                                                    <img src="../../assets/images/actions/edit.svg"
                                                        alt="Edit Button"
                                                        class="action-button"
                                                        @click="handleEdit(data.item, data.index)"
                                                    />
                                                </b-col>
                                            </b-row>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                            <div>
                                <b-row>
                                    <b-col>
                                        <div class="mt-1">
                                            <span class="pagination-indicator">{{ pagination.currentFirstItem }}-{{ pagination.currentLastItem }} of {{ pagination.maxPage }}</span>
                                            <b-pagination
                                                hide-goto-end-buttons
                                                align="left"
                                                size="md"
                                                :limit="3"
                                                :total-rows="maxPage * list.length"
                                                :per-page="list.length"
                                                v-model="currentPage"
                                                class="custom-pagination-arrow-only mb-0 ml-2">
                                            </b-pagination>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>

                    <!-- Right wing -->

                    <b-col sm="12" md="4" class="pl-md-0 pr-md-0">
                        <div id="mobile-outline" style="height: 680px;" >
                            <div class="mx-auto" style="padding: 74px 0px; width: 270px;">
                                <h5 class="mb-3">Achievements</h5>
                                <b-row>
                                    <template v-if="outlineAchievements.length == 0">
                                        <b-col cols="6">
                                            <div class="achievement-empty-badge rounded-circle">
                                                <img src="@/assets/images/achievement/default-image.svg" alt="Default Image">
                                            </div>
                                        </b-col>
                                    </template>
                                    <template v-else>
                                        <b-col cols="6"
                                            v-for="(mrow, index) in outlineAchievements"
                                            :key="index"
                                            class="mb-3">
                                            <div v-for="(row) in mrow"
                                                :key="row.achievement_unlock_config_id"
                                                class="achievement-badge rounded-circle"
                                                :style="[{'background-image': 'url(' + row.logo_image + ')'}, {'background-size': 'contain'}]">
                                                <span class="d-inline-block">{{ row.milestone }}</span>
                                                <span v-if="!isWelcomeDiscount(row.name)" class="d-inline-block">{{ row.points }} pts.</span>
                                            </div>
                                        </b-col>
                                    </template>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>


        <!-- MODALS -->

        <!-- Upload modal -->
        <b-modal id="uploadBadgeIcon" title="Upload Image">
            <div id="badge-icon-upload-container" class="border mx-auto">
                <croppa
                    v-model="croppa"
                    @new-image-drawn="onNewImage"
                    @zoom="onZoom"
                    :width="200"
                    :height="200"
                    placeholder="Choose an Image"
                    :show-remove-button="true"
                    :placeholder-font-size="14"
                    :prevent-white-space="true"
                    remove-button-color="#ff8828">
                </croppa>
            </div>
            <div id="badge-icon-range-container" class="mx-auto mt-2">
                <input type="range" class="custom-range" id="customRange1" @input="onSliderChange" :min="sliderMin" :max="sliderMax" step=".001" v-model="sliderVal">
            </div>
            <div slot="modal-footer">
                <b-button variant="ghost" class="btn-cancel" style="margin-right: .25rem;" @click="showModal('edit-target')">
                    Cancel
                </b-button>
                <b-button variant="primary" style="margin-left: .25rem;" @click="showModal('edit-target')">
                    Save
                </b-button>
            </div>
        </b-modal>

        <!-- Edit modal -->
        <b-modal id="edit-target" title="Edit Badge" size="lg"
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-form pt-2">
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Title</h6>
                    </b-col>
                    <b-col>
                        <b-form-group id="badgeTitleGroup"
                            label=" Badge Title"
                            label-for="badgeTitle"
                            class="secondary-label mb-2">
                            <b-form-input id="badgeTitle"
                                type="text"
                                v-model="form.badgeTitle"
                                required>
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <hr class="form-divider">
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Badge</h6>
                        <span class="label-helper d-inline-block">(200 x 200)</span>
                    </b-col>
                    <b-col>
                        <div class="upload-badge-container text-center mb-1" v-b-modal.uploadBadgeIcon>
                            <span class="secondary-label d-block mb-2">Upload Badge Icon</span>
                            <div class="upload-badge rounded-circle border">
                                <img v-if="form.logoImage !== '' && form.logoImage !== null" :src="form.logoImage" alt="Sample Badge" class="rounded-circle">
                                <div class="upload-icon rounded-circle border">
                                </div>

                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <hr class="form-divider">
                    </b-col>
                </b-row>
                <template>
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Points</h6>
                        </b-col>
                        <b-col>
                            <template v-if="!points_multiplier.status">
                                <span class="secondary-label align-top">Conversion</span>
                                <div class="form-container">
                                    <b-row no-gutters>
                                        <b-col cols="3">
                                            <div class="mt-1">
                                                <i class="d-inline-block">
                                                    <img src="@/assets/images/badge.svg" class="mr-2" alt="Badge Icon">
                                                </i>
                                                <span class="d-inline-block align-middle label">Badge</span>
                                            </div>
                                        </b-col>
                                        <b-col cols="1">
                                            <i class="d-inline-block mt-1">
                                                <img src="@/assets/images/mechanics/convert.svg" alt="Convert Icon">
                                            </i>
                                        </b-col>
                                        <b-col cols="3">
                                            <div class="mt-1">
                                                <i class="d-inline-block ml-2">
                                                    <img src="@/assets/images/mechanics/points.svg" class="mr-2" alt="Points Icon">
                                                </i>
                                                <span class="d-inline-block align-middle label">Points</span>
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div class="pl-1">
                                                <b-form-input
                                                    v-model="form.points"
                                                    type="number"
                                                    placeholder="0"
                                                    min="0"
                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    title="Numbers only">
                                                </b-form-input>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </template>
                            <b-row>
                                <b-col cols="6">
                                    <div class="mt-4">
                                        <span class="secondary-label d-block mb-1">Points Expiry</span>
                                        <switches
                                            id="toggle-points-expiry"
                                            v-model="form.pointsExpiry"
                                            theme="custom"
                                            color="primary"
                                            type-bold="true"
                                            text-enabled="On"
                                            text-disabled="Off"
                                            style="position: absolute; top: 38px;"
                                        ></switches>
                                    </div>
                                </b-col>
                                <b-col cols="6" class="mb-2">
                                    <div class="mt-4">
                                        <b-form-group :state="isValid('points_validity')" :invalid-feedback="errorMessage('point_validity')">
                                            <span class="secondary-label d-block mb-1">Validity</span>
                                            <b-form-select v-model="form.selectedValidity" :options="form.validityOptions"/>
                                        </b-form-group>
                                    </div>
                                </b-col>
                            </b-row>
                            <template v-if="member_activation_field.status">
                                <b-row class="mt-3">
                                    <b-col cols="6">
                                        <b-form-group
                                            label="Start Date"
                                            label-for="start_date"
                                            label-class="secondary-label"
                                            class="secondary-label mb-3 sl-helper">
                                            <b-input-group class="custom-datepicker mb-1 muli-sb d-flex shadow-none">
                                                <b-input-group-text slot="append" class="bg-transparent">
                                                    <img src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button"
                                                        @click="openCalendar('start')">
                                                </b-input-group-text>
                                                <SingleDatepicker :bootstrap-styling="true"
                                                    :value="form.start_date"
                                                    ref="datepicker_start"
                                                    v-model="member_activation_field.start_date"
                                                    wrapper-class="custom-datepicker"
                                                    style="color: #2a2a2a !important; width: 140px;"
                                                    :disabledDates="disabledDates"/>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="6">
                                        <b-form-group
                                            label="End Date"
                                            label-for="end_date"
                                            label-class="secondary-label"
                                            class="secondary-label mb-3 sl-helper">
                                            <b-input-group class="custom-datepicker mb-1 muli-sb d-flex shadow-none">
                                                <b-input-group-text slot="append" class="bg-transparent">
                                                    <img src="../../assets/images/icons/calendar.svg" alt="Calendar Icon" class="form-icon action-button"
                                                        @click="openCalendar('end')">
                                                </b-input-group-text>
                                                <SingleDatepicker :bootstrap-styling="true"
                                                    :value="form.end_date"
                                                    ref="datepicker_end"
                                                    v-model="member_activation_field.end_date"
                                                    wrapper-class="custom-datepicker"
                                                    style="color: #2a2a2a !important; width: 140px;"
                                                    :disabledDates="disabledEndDates"/>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <small class="text-danger" v-if="errorMessage('options') != ''">
                                    {{ errorMessage('options') }}
                                </small>
                            </template>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mb-2">
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                </template>
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Description</h6>
                    </b-col>
                    <b-col>
                        <b-form-group
                            id="milestoneDescriptionGroup"
                            label-for="milestoneDescription"
                            :label="'Milestone Description - ' + milestoneDescriptionLabel"
                            class="secondary-label mb-2">
                            <b-form-textarea
                                v-model="form.milestoneDescription"
                                placeholder="Enter description"
                                :maxlength="form.maxMilestoneDescription"
                                :rows="4"
                                :max-rows="6">
                            </b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <template v-if="isShowAudience">
                    <template v-if="manual_seeding.status === false">
                        <b-row>
                            <b-col>
                                <hr class="form-divider">
                            </b-col>
                        </b-row>
                        <b-row no-gutters>
                            <b-col sm="12" md="3">
                                <h6 class="main-label">Audience</h6>
                                </b-col>
                            <b-col>
                                <b-form-group id="targetSegmentGroup"
                                    label="Target Segment"
                                    label-for="targetSegment"
                                    class="secondary-label mb-2">
                                    <b-form-select id="targetSegment" v-model="form.selectedTargetSegment" :options="form.targetSegmentOptions" class="muli-sb"/>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </template>
                </template>
                <b-row>
                    <b-col>
                        <hr class="form-divider">
                    </b-col>
                </b-row>
                <template v-if="manual_seeding.status">
                    <b-row no-gutters>
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Points Seeding</h6>
                            </b-col>
                        <b-col>
                            <b-form-group
                                label="Upload CSV"
                                label-for="seeding_csv"
                                label-class="d-block secondary-label"
                                :invalid-feedback="errorMessage('csv')"
                                :state="isValid('csv')">
                                <b-form-file
                                    v-model="manual_seeding.seeding_csv"
                                    :state="manual_seeding.seeding_csv === null ? null : isValidCSV"
                                    accept=".csv"
                                    placeholder="Choose a file..."
                                    drop-placeholder="Drop file here..."
                                    ref="upload_csv">
                                </b-form-file>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                </template>
                <template v-if="points_multiplier.status">
                    <b-row no-gutters v-if="points_multiplier.status !== true">
                        <b-col sm="12" md="3">
                            <h6 class="main-label">Points</h6>
                        </b-col>
                        <b-col>
                            <span class="secondary-label align-top">Conversion</span>
                            <div class="form-container">
                                <b-row no-gutters>
                                    <b-col cols="3">
                                        <div class="mt-1">
                                            <i class="d-inline-block">
                                                <img src="@/assets/images/badge.svg" class="mr-2" alt="Badge Icon">
                                            </i>
                                            <span class="d-inline-block align-middle label">Badge</span>
                                        </div>
                                    </b-col>
                                    <b-col cols="1">
                                        <i class="d-inline-block mt-1">
                                            <img src="@/assets/images/mechanics/convert.svg" alt="Convert Icon">
                                        </i>
                                    </b-col>
                                    <b-col cols="3">
                                        <div class="mt-1">
                                            <i class="d-inline-block ml-2">
                                                <img src="@/assets/images/mechanics/points.svg" class="mr-2" alt="Points Icon">
                                            </i>
                                            <span class="d-inline-block align-middle label">Points</span>
                                        </div>
                                    </b-col>
                                    <b-col>
                                        <div class="pl-1">
                                            <b-form-input
                                                v-model="form.points"
                                                type="number"
                                                placeholder="0"
                                                min="0">
                                            </b-form-input>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row>
                                <b-col cols="6">
                                    <div class="mt-4">
                                        <span class="secondary-label d-block mb-1">Points Expiry</span>
                                        <switches
                                            id="toggle-points-expiry"
                                            v-model="form.pointsExpiry"
                                            theme="custom"
                                            color="primary"
                                            type-bold="true"
                                            text-enabled="On"
                                            text-disabled="Off"
                                            style="position: absolute; top: 38px;"
                                        ></switches>
                                    </div>
                                </b-col>
                                <b-col cols="6" class="mb-2">
                                    <div class="mt-4">
                                        <b-form-group :state="isValid('points_validity')" :invalid-feedback="errorMessage('point_validity')">
                                            <span class="secondary-label d-block mb-1">Validity</span>
                                            <b-form-select v-model="form.selectedValidity" :options="form.validityOptions"/>
                                        </b-form-group>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row v-if="points_multiplier.status !== true">
                        <b-col class="mb-2">
                            <hr class="form-divider">
                        </b-col>
                    </b-row>

                    <PointsMultiplier :values="points_multiplier"
                        @addMultiplier="addMultiplier"
                        @deleteMultiplier="deleteMultiplier" />

                    <b-row>
                        <b-col class="mb-2">
                            <hr class="form-divider">
                        </b-col>
                    </b-row>
                </template>
                <b-row no-gutters>
                    <b-col sm="12" md="3">
                        <h6 class="main-label">Visibility</h6>
                    </b-col>
                    <b-col>
                        <div>
                            <span class="d-block mb-3 secondary-label">Publish in App</span>
                            <switches
                                id="toggle-publish-in-app"
                                v-model="form.appVisibility"
                                theme="custom"
                                color="primary"
                                type-bold="true"
                                text-disabled="Off"
                                text-enabled="On"
                                style="top: -20px;">
                            </switches>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer">
                <b-btn variant="ghost" v-bind:disabled="loading" class="mr-1 btn-cancel" @click="hideModal('edit-target')">
                    Cancel
                </b-btn>
                <b-btn variant="primary" v-bind:disabled="loading" class="ml-1" @click="updateAchievement">
                    <template v-if="loading">
                        Saving...
                    </template>
                    <template v-else>
                        Save
                    </template>
                </b-btn>
            </div>
        </b-modal>
        <WelcomeDiscountModal />
    </div>
</template>

<script>
import Switches from "vue-switches-2";
import { mapState, mapGetters } from "vuex";
import _ from "lodash";
import notification from "../../services/notification";
import SingleDatepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import PointsMultiplier from "./points-multiplier/PointsMultiplier";
import WelcomeDiscountModal from "@/components/mechanics/WelcomeDiscountModal";

export default {
    name: "achievement",
    components: {
        Switches,
        SingleDatepicker,
        VueTimepicker,
        PointsMultiplier,
        WelcomeDiscountModal
    },

    data() {
        return {
            form: {
                badgeTitle: "",
                pointsExpiry: true,
                points: 0,
                milestoneDescription: "",
                selectedValidity: 0,
                validityOptions: [
                    { value: 1, text: "1 year" },
                    { value: 2, text: "2 years" }
                ],
                selectedTargetSegment: null,
                targetSegmentOptions: [],
                appVisibility: true,
                logoImage: null,
                uuid: null,
                index: null,
                maxMilestoneDescription: 200,
                start_date: null,
                end_date: null
            },

            fields: [
                "no",
                { key: "milestone", label: "Badges" },
                { key: "published", label: "Visibility" },
                { key: "id", label: "Action" }
            ],

            toEdit: null,

            croppa: {},
            sliderVal: 0,
            sliderMin: 0,
            sliderMax: 0,

            member_activation_field: {
                status: false,
                start_date: new Date(),
                end_date: new Date()
            },
            disabledDates: {
                to: new Date(Date.now() - 864e5)
            },

            isValidCSV: null,

            manual_seeding: {
                status: false,
                seeding_csv: null
            },
            options: null,
            points_multiplier: {
                status: false,
                enable_branch: 0,
                days: [
                    { value: "sun", text: "S" },
                    { value: "mon", text: "M" },
                    { value: "tue", text: "T" },
                    { value: "wed", text: "W" },
                    { value: "thu", text: "Th" },
                    { value: "fri", text: "F" },
                    { value: "sat", text: "S" }
                ],
                frequencies: [
                    { value: null, text: "Select", disabled: true },
                    { value: "daily", text: "Daily" },
                    { value: "weekly", text: "Weekly" },
                    { value: "monthly", text: "Monthly" },
                    { value: "yearly", text: "Yearly" }
                ],
                multipliers: [
                    {
                        branch: null,
                        selected_option: "day",
                        days: [],
                        start_date: new Date(),
                        end_date: new Date(),
                        enable_time: false,
                        start_time: {
                            HH: new Date().getHours(),
                            mm: this.transformMinutes(new Date().getMinutes())
                        },
                        end_time: {
                            HH: new Date().getHours(),
                            mm: this.transformMinutes(new Date().getMinutes())
                        },
                        enable_frequency: false,
                        frequency: 1,
                        frequency_range: null,
                        multiplier: 1
                    }
                ]
            },
            isShowAudience: true
        };
    },

    created: function() {
        let _this = this;

        _this.initPage();

        let addObject = {
            value: "",
            text: "All"
        };
        _this.form.targetSegmentOptions.push(addObject);

        _this.$store
            .dispatch("achievements/getTargetSegmentOptions")
            .then(response => {
                _.forEach(response.options, function(value) {
                    let object = {
                        value: value.target_segment_uuid,
                        text: value.name
                    };
                    _this.form.targetSegmentOptions.push(object);
                });
            });
    },

    computed: {
        ...mapState("achievements", [
            "list",
            "page",
            "maxPage",
            "nextPage",
            "prevPage",
            "currentPage",
            "detail",
            "loading",
            "errors",
            "pagination"
        ]),
        milestoneDescriptionLabel: {
            get: function() {
                if (this.form.milestoneDescription != null) {
                    return (
                        this.form.milestoneDescription.length +
                        " / " +
                        this.form.maxMilestoneDescription
                    );
                }
                return "0 / " + this.form.maxMilestoneDescription;
            }
        },

        ...mapGetters("achievements", ["outlineAchievements"]),

        disabledEndDates: function() {
            return  {
                to: new Date(this.member_activation_field.start_date - 8640000)
            };
        }
    },

    methods: {
        async getAchievements(page) {
            await this.$store.dispatch("achievements/getList", page);
        },
        async initPage() {
            await this.getAchievements(1);
        },
        isWelcomeDiscount(achievement) {
          return achievement === 'dine_in_welcome_promo_code';
        },
        handleEdit(item, index) {
          if (this.isWelcomeDiscount(item.name))
            this.$root.$emit("bv::show::modal", 'welcome-discount-modal');
          else
            this.editPointsAchievement(item, index);
        },
        editPointsAchievement(achievement, index) {
            this.croppa.remove();
            this.showModal("edit-target")
            this.form.index = index;
            this.form.uuid = achievement.achievement_unlock_config_id;
            this.form.badgeTitle = achievement.milestone;
            this.form.points = achievement.points;
            this.form.pointsExpiry = achievement.point_expiry;
            this.form.selectedValidity = achievement.point_validity;
            this.form.milestoneDescription = achievement.description;
            this.form.appVisibility = achievement.published;
            this.form.logoImage = achievement.logo_image;
            this.form.selectedTargetSegment = achievement.target_segment_uuid;

            this.member_activation_field.status = achievement.name === "member_activation";
            this.manual_seeding.status = achievement.name === "manual_seeding";
            this.points_multiplier.status = achievement.name === "points_multiplier";

            if (this.manual_seeding.seeding_csv != null) {
                this.$refs.upload_csv.reset();
            }

            let options = JSON.parse(achievement.options);

            this.$store.commit("achievements/setErrors", null);
            
            if (this.member_activation_field.status) {
                this.member_activation_field.start_date = options.start_date ? new Date(options.start_date) : new Date();
                this.member_activation_field.end_date = options.end_date ? new Date(options.end_date) : new Date();
            }

            this.$store.commit("achievements/setPointsMultiplier", this.points_multiplier.status);

            if (this.points_multiplier.status) {
                let multiplier_settings = options.multiplier_settings;
                let multipliers = multiplier_settings.map(setting => {
                    return {
                        branch: setting.specify_branch === 1 ? setting.branch_uuid : null,
                        multiplier: setting.multiplier ? setting.multiplier : 0,
                        selected_option: setting.day_date_range === 1 ? "day" : "dateRange",
                        days: setting.day_date_range == 1
                            ? setting.range_days : null,
                        start_date: setting.day_date_range == 2
                            ? setting.start_date : new Date(),
                        end_date: setting.day_date_range == 2
                            ? setting.end_date : new Date(),
                        enable_time: setting.specify_time == 1,
                        start_time: setting.specify_time == 1
                            ? {
                                HH: setting.start_time.split(":")[0],
                                mm: setting.start_time.split(":")[1]
                            } : {
                                HH: new Date().getHours(),
                                mm: this.transformMinutes(new Date().getMinutes())
                            },
                        end_time: setting.specify_time == 1
                            ? {
                                HH: setting.end_time.split(":")[0],
                                mm: setting.end_time.split(":")[1]
                            } : {
                                HH: new Date().getHours(),
                                mm: this.transformMinutes(new Date().getMinutes())
                            },
                        enable_frequency: setting.specify_frequency === 1,
                        frequency: setting.frequency,
                        frequency_range: setting.frequency_range
                    }
                });
                this.points_multiplier.enable_branch = multiplier_settings[0].specify_branch === 1;
                this.points_multiplier.multipliers = multipliers;
            }
            // Hide or Show Audience
            this.isShowAudience = true; // reset to true
            switch (achievement.name) {
                case "member_complete_profile":
                case "member_referral":
                case "member_activation":
                case "points_multiplier":
                    this.isShowAudience = false;
                    break;
            }
        },
        validateAchievement() {
            this.$store.commit("achievements/setErrors", null);
            const fieldRequiredError = "This field is required.";
            const errors = {};
            
            if (this.form.pointsExpiry && !this.form.selectedValidity)
                errors['point_validity'] = fieldRequiredError;

            if (Object.keys(errors).length)
                this.$store.commit("achievements/setErrors", errors);
        },  
        async updateAchievement() {
            this.validateAchievement();

            if (!this.errors) {
                let _this = this;

                await this.$store.commit("achievements/setMembershipActivation", _this.member_activation_field.status);
                await this.$store.commit("achievements/setManualSeeding", _this.manual_seeding.status);

                if (this.member_activation_field.status) {
                    this.form.start_date = this.formatDate(this.member_activation_field.start_date);
                    this.form.end_date = this.formatDate(this.member_activation_field.end_date);
                }

                if (this.points_multiplier.status) {

                    let multipliers = this.points_multiplier.multipliers;

                    let multiplier_settings = multipliers.map(multiplier => {
                        return {
                            specify_branch: this.points_multiplier.enable_branch ? 1 : 0,
                            branch_uuid: multiplier.branch,
                            multiplier: multiplier.multiplier,
                            day_date_range: multiplier.selected_option == "day" ? 1 : 2,
                            range_days: multiplier.selected_option == "day" ? multiplier.days : null,
                            start_date: multiplier.selected_option == "dateRange"
                                ? this.$moment(multiplier.start_date).format("YYYY-MM-DD") : null,
                            end_date: multiplier.selected_option == "dateRange"
                                ? this.$moment(multiplier.end_date).format("YYYY-MM-DD") : null,
                            specify_time: multiplier.enable_time ? 1 : 0,
                            start_time: multiplier.enable_time
                                ? multiplier.start_time.HH + ":" + multiplier.start_time.mm : null,
                            end_time: multiplier.enable_time
                                ? multiplier.end_time.HH + ":" + multiplier.end_time.mm : null,
                            specify_frequency: multiplier.enable_frequency ? 1 : 0,
                            frequency: multiplier.enable_frequency ? multiplier.frequency : 1,
                            frequency_range: multiplier.enable_frequency ? multiplier.frequency_range : null
                        }
                    });

                    this.$store.commit("achievements/setMultiplierDetail", multiplier_settings);
                }

                this.$store.commit("achievements/setDetail", this.form);

                this.$store
                    .dispatch("achievements/updateAchievement")
                    .then(response => {
                        if (response != undefined) {
                            _.forEach(response.achievement_unlock_config, function(
                                value,
                                key
                            ) {
                                _this.list[_this.form.index][key] = value;
                            });

                            notification.success(response.message);
                        
                            _this.hideModal("edit-target");

                            _this.$store.commit("achievements/clearSeedingFile");
                        }
                    });
            } else notification.warning("Oops, something went wrong.");
        },

        //predefined
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        showModal(modal) {
            this.$root.$emit("bv::show::modal", modal);

            this.form.logoImage = this.croppa.generateDataUrl();
        },
        onNewImage() {
            this.sliderVal = this.croppa.scaleRatio;
            this.sliderMin = this.croppa.scaleRatio / 2;
            this.sliderMax = this.croppa.scaleRatio * 2;
        },
        onSliderChange(evt) {
            let increment = evt.target.value;
            this.croppa.scaleRatio = +increment;
        },
        onZoom() {
            this.sliderVal = this.croppa.scaleRatio;
        },

        formatDate: function(date) {
            return this.$moment(date).format("YYYY-MM-DD");
        },

        openCalendar(type) {
            let calendar = "datepicker_" + type;
            this.$refs[calendar].showCalendar();
        },

        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },

        isValid(field) {
            if (this.errors == null) {
                return false;
            }

            return !this.errors[field];
        },

        transformMinutes: function(minutes) {
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            return minutes;
        },

        addMultiplier: function() {
            let new_branch = {
                branch: null,
                selected_option: "day",
                days: [],
                start_date: new Date(),
                end_date: new Date(),
                enable_time: false,
                start_time: {
                    HH: new Date().getHours(),
                    mm: this.transformMinutes(new Date().getMinutes())
                },
                end_time: {
                    HH: new Date().getHours(),
                    mm: this.transformMinutes(new Date().getMinutes())
                },
                enable_frequency: false,
                frequency: 1,
                multiplier: 1,
                frequency_range: null
            }

            this.points_multiplier.multipliers.push(new_branch);
        },

        deleteMultiplier: function(index) {
            this.points_multiplier.multipliers.splice(index, 1);
        }
    },

    watch: {
        "manual_seeding.seeding_csv": function(file) {
            if (file !== null) {
                if ((file.type === "text/csv" || file.name.split(".").pop() === "csv")) {
                    let size = (file.size * 0.00000095367432).toFixed(4);
                    if (size > 2) {
                        notification.warning(
                            "Oops, the file you are trying to upload is larger than 2mb."
                        );
                        this.isValidCSV = false;
                    } else {
                        this.isValidCSV = true;
                        this.$store.commit("achievements/setImportFile", this.manual_seeding.seeding_csv);
                        this.$store.dispatch("achievements/readImportFile");
                    }
                } else {
                    notification.warning("Oops, the file you are trying to upload is not a valid .csv file.");
                    this.$store.commit("achievements/setImportFile", null);
                    this.$store.dispatch("achievements/readImportFile");
                    this.$refs.upload_csv.reset();
                }
            }
        },
        "form.pointsExpiry"(value) {
          if (!value) this.form.selectedValidity = null;
        }
    }
};
</script>

<style lang="scss" scoped>
.vue-switcher {
  opacity: 0.5;
  input {
    cursor: default;
  }
}
</style>

<style lang="scss">
#achievement-tab {
    .invalid-feedback {
        display: block;
    }
}
</style>
